import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCityModal from "../components/AddCityModal";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch, useSelector } from "react-redux";
import { cityActions } from "../duck/CityReducer";
import CircularProgress from "@mui/material/CircularProgress";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const AddCityAccordian = (props) => {
  const { title, expanded, setReorderedCities } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { list, citiesMap, loading, storeLocationCities } = useSelector(
    ({ city }) => city
  );

  console.log("this is the list", citiesMap);
  console.log("this si state cities only locations", storeLocationCities);

  useEffect(() => {
    dispatch(cityActions.onGetCities());
    dispatch(cityActions.onGetOnlyStateCities());
  }, [dispatch]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverCityId, setPopoverCityId] = useState(null);

  const [selectedCityId, selectCity] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [localCities, setLocalCities] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    setCities(
      Array.isArray(storeLocationCities)
        ? storeLocationCities
        : Object.values(storeLocationCities || {})
    );
  }, [storeLocationCities]);

  const handleModal = useCallback((show = false, id) => {
    show = typeof show === "boolean" && show;
    setShowModal(show);
    selectCity(id);
  }, []);

  const handleRemove = useCallback(
    (_id) => {
      setAnchorEl(null);
      setPopoverCityId(null);
      setCities((prev) => prev.filter((city) => city._id !== _id));

      // Remove from reorderedCities so Save doesn't bring it back

      dispatch(cityActions.onDeleteCity({ _id }));
      // dispatch(cityActions.onGetCities());
      // dispatch(cityActions.onGetOnlyStateCities());
    },
    [dispatch]
  );

  useEffect(() => {
    setCities(
      Array.isArray(storeLocationCities)
        ? storeLocationCities
        : Object.values(storeLocationCities || {})
    );
  }, [storeLocationCities]);

  const handlePopover = useCallback((event, cityId) => {
    setAnchorEl(event.currentTarget);
    setPopoverCityId(cityId);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
    setPopoverCityId(null);
  }, []);

  const citiesArray = Array.isArray(storeLocationCities)
    ? storeLocationCities
    : Object.values(storeLocationCities || {});

  // const handleDragEnd = (result) => {
  //   if (!result.destination) return;

  //   const reordered = Array.from(localCities);
  //   const [moved] = reordered.splice(result.source.index, 1);
  //   reordered.splice(result.destination.index, 0, moved);

  //   setLocalCities(reordered); // triggers re-render

  //   // Optional: update backend or Redux
  //   // dispatch(cityActions.onUpdateCityOrder(reordered));
  // };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(cities);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    setCities(reordered);

    if (setReorderedCities) {
      setReorderedCities(reordered); // pass new order to parent
    }
  };

  useEffect(() => {
    setLocalCities(
      Array.isArray(storeLocationCities)
        ? storeLocationCities
        : Object.values(storeLocationCities || {})
    );
  }, [storeLocationCities]);

  const handleCityUpdated = (updatedCity) => {
    setCities((prev) =>
      prev.map((city) =>
        city._id === updatedCity._id ? { ...city, ...updatedCity } : city
      )
    );
  };

  return (
    <>
      <Accordion expanded={expanded}>
        <AccordionSummary aria-controls="panel2a-content" id="panel2a-header">
          <Typography fontWeight={"600"}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="btn-container mt15">
            <Button
              variant="contained"
              className="bordered-button float-right"
              onClick={() => handleModal(true)}
            >
              + Add City
            </Button>
          </div>

          {loading ? (
            <CircularProgress style={{ marginLeft: "auto" }} />
          ) : (
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="cities">
                {(provided) => (
                  <TableContainer
                    component={Paper}
                    sx={{ mt: 2 }}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    <Table
                      sx={{ minWidth: 650, px: 2 }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ fontWeight: 700 }}
                            align="left"
                            className="tablecell"
                          >
                            State
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: 700 }}
                            align="left"
                            className="tablecell"
                          >
                            City
                          </TableCell>

                          <TableCell
                            style={{ fontWeight: 700 }}
                            align="left"
                            className="tablecell"
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {cities.map((mCity, index) => (
                          <Draggable
                            key={mCity._id}
                            draggableId={mCity._id}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <TableRow
                                // key={index}
                                key={mCity._id}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell
                                  align="left"
                                  component="th"
                                  scope="row"
                                >
                                  <Box className="origin_des">
                                    <Box>
                                      <Typography
                                        style={{
                                          maxWidth: 200,
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="font600 fs_14"
                                      >
                                        {/* {mCity?.state} */}
                                        {mCity?.state}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  component="th"
                                  scope="row"
                                >
                                  <Box className="origin_des">
                                    <Box
                                      sx={{
                                        ml: 3,
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          maxWidth: 400,
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="font600 fs_14"
                                      >
                                        {/* {mCity?.city} */}
                                        {mCity?.city}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>

                                <TableCell align="left">
                                  <MoreVertIcon
                                    id={mCity?._id}
                                    // onClick={handlePopover}
                                    onClick={(e) => handlePopover(e, mCity._id)}
                                  />
                                  <Popover
                                    id="simple-popover"
                                    // open={anchorEl?.id === mCity?._id}
                                    // open={popoverCityId === mCity._id}
                                    open={
                                      popoverCityId === mCity._id &&
                                      !!cities.find((c) => c._id === mCity._id)
                                    }
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        padding: 5,
                                        alignItems: "center",
                                        textAlign: "center",
                                      }}
                                      className="pointer"
                                      onClick={() =>
                                        navigate(
                                          `/dashboard/editStore/${mCity?._id}`
                                        )
                                      }
                                    >
                                      <RemoveRedEyeIcon
                                        style={{ fontSize: 16 }}
                                        className="mr5"
                                      />
                                      Details
                                    </Typography>
                                    <Typography
                                      className="pointer"
                                      onClick={() => {
                                        handleClose();
                                        handleModal(true, mCity?._id);
                                      }}
                                    >
                                      <EditIcon
                                        style={{ fontSize: 16 }}
                                        className="mr10"
                                      />
                                      Edit
                                    </Typography>
                                    <Typography
                                      className="pointer"
                                      onClick={() => handleRemove(mCity?._id)}
                                    >
                                      <DeleteIcon
                                        style={{ fontSize: 16 }}
                                        className="mr5"
                                      />
                                      Delete
                                    </Typography>
                                  </Popover>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </AccordionDetails>
      </Accordion>
      <AddCityModal
        open={showModal}
        handleClose={() => setShowModal(false)}
        selectedCityId={selectedCityId}
        onCityAdded={(newCity) => setCities((prev) => [...prev, newCity])}
        onCityUpdated={handleCityUpdated}
      />
    </>
  );
};

export default AddCityAccordian;
